<template>
  <div class="churn-validate-action-popup">
    <churn-popup :buttons="buttonOptions" :back-action="back">
      <template v-slot:popup-content>
        <churn-validate-action-popup-content/>
      </template>
    </churn-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import ChurnPopup from './ChurnPopup.vue';
import ChurnValidateActionPopupContent from './ChurnValidateActionPopupContent.vue';
import ChurnDescriptionPopup from './ChurnDescriptionPopup.vue';
import router from '../../../../router';
import ModalBus from '../../../../event-bus/modal-bus';
import Segment from '../../../../Segment';

export default {
  name: 'ChurnValidateActionPopup',
  components: {
    ChurnPopup,
    ChurnValidateActionPopupContent,
  },
  created() {
    Segment.trackUserInteraction('ChurnValidateActionPopup_Shown');
  },
  computed: {
    ...mapState('session', ['customerId']),
    ...mapState('churn', ['churnValidated']),
    ...mapState('subscriptionState', ['subscriptionState']),
    buttonOptions() {
      return [{
        title: 'סגירת ומחיקת החשבון',
        action: this.churn,
        variant: 'danger',
        disabled: !this.churnValidated,
      }];
    },
  },
  methods: {
    ...mapActions('churn', ['churnCustomer']),
    back() {
      Segment.trackUserInteraction('ChurnValidateActionPopup_BackClicked');
      ModalBus.$emit('open', {
        component: ChurnDescriptionPopup,
        props: {},
      });
    },
    async churn() {
      Segment.trackUserInteraction('ChurnValidateActionPopup_ChurnConfirmed');
      this.$emit('close');
      this.churnCustomer();
      localStorage.setItem('riseup.churnSurvey', JSON.stringify({ id: this.customerId, state: this.subscriptionState }));
      router.push({ path: '/goodbye' });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/churn/ChurnValidateActionPopup.vue